import Marquee from "react-fast-marquee";

const WORDS = ["Étanchéité", "Isolation thermique", "Couvertine", "Dalles sur plots", "Murs enterrés", "Garantie décennale"];

export const Ticker = () => {
  return (
    <div className="border-y border-mh-line bg-mh-bg py-6 overflow-hidden">
      <Marquee speed={45} gradient={false} autoFill>
        {WORDS.map((w, i) => (
          <div key={i} className="flex items-center">
            <span className="font-display font-black uppercase text-4xl sm:text-6xl tracking-tight text-stroke px-8">
              {w}
            </span>
            <span className="w-2 h-2 rounded-full bg-mh-orange" />
          </div>
        ))}
      </Marquee>
    </div>
  );
};
